import { render, staticRenderFns } from "./BoryxHomeHero.vue?vue&type=template&id=17c84e5a&scoped=true"
import script from "./BoryxHomeHero.vue?vue&type=script&lang=js"
export * from "./BoryxHomeHero.vue?vue&type=script&lang=js"
import style0 from "./BoryxHomeHero.vue?vue&type=style&index=0&id=17c84e5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c84e5a",
  null
  
)

export default component.exports